import {getCookies} from '@/utils/cookies'
import Nowak from '@/api/Nowak'
import SystemSetting from '@/View/SystemSetting/SystemSettingApi/SystemSetting'

const user = {
  state: {
    token: getCookies('authToken'),
    name: '',
    avatar: '',
    permission: [],
    isAdmin: '',
    dateTimeFormat: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONS: (state, permission) => {
      state.permission = permission
    },
    SET_MENULIST: (state, menuList) => {
      state.menuList = menuList
    },
    SET_ADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    },
    SET_DATETIME_FORMAT: (state, dateformat) => {
      state.dateTimeFormat = dateformat
    }
  },
  actions: {
    SetName ({commit}, Name) {
      commit('SET_NAME', Name)
    },
    SetToken ({commit}, token) {
      commit('SET_TOKEN', token)
    },
    SetAvatar ({commit}, avatar) {
      commit('SET_AVATAR', avatar)
    },
    SetMenuList ({commit}, menuList) {
      commit('SET_MENULIST', menuList)
    },
    SetAdmin ({commit}, isadmin) {
      commit('SET_ADMIN', isadmin)
    },
    SetDateTimeFormat ({commit}) {
      SystemSetting.getGeneralData(
        'localization',
        response => {
          if (response.Data !== null) {
            for (let i = 0; i < response.Data.length; i++) {
              if (response.Data[i].optionSlug === 'date_format') {
                commit('SET_DATETIME_FORMAT', response.Data[i].value)
                break
              }
            }
          }
        },
        () => {}
      )
    },
    GetEmployeePermission ({commit}, logOut) {
      if (logOut) {
        commit('SET_PERMISSIONS', [])
      } else {
        Nowak.GetLogedInEmployeePermissions(
          response => {
            commit('SET_PERMISSIONS', response.Data)
          },
          error => {
            console.error(error)
          }
        )
      }
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js